<template>
<div class="foundation">
    <div class="entry">
        <div class="item_entry">
            <h3>入驻公益节点，实现极速筹款！</h3> 
            <h4>目前已有<i> {{OrgsList.count}} </i>个公募基金会加入</h4> 
            <!-- <div class="apply_join">申请加入</div> -->
        </div>
    </div>

    <div class="item" v-for="(item, i) in OrgsList.list" :key="i">
        <!-- <a href="https://yglian.qschou.com/gongyi/publicSite/index?ChannelId=zhech"> -->
            <div class="project_wrap">
                <div class="product_content">
                    <h2 class="item_title">{{item.name}}</h2>
                    <p class="item_intro">{{item.detail}}</p>
                    <div class="item_bottom">
                        <div class="item_bottom_num">
                            总筹款<span> {{item.donate_total}} </span> 元
                        </div>
                        <div class="item_bottom_num">
                            总支持 <span> {{item.order_total}} </span> 次
                        </div>
                    </div>
                </div> 
                <div class="product_img">
                    <img data-original="#" :src="item.cover" class="lazyload" style="display: inline;">
                </div>
            </div>
        <!-- </a> -->
    </div>
</div>
</template>
<script>
import axios from 'axios'

export default {
    data () {
        return {
            OrgsList:[]
        }
    },
    methods: {
        getOrgs() {
            axios.get('https://partner-gateway.qschou.com/official/orgs?type=1').then((res) => {
                res = res.data;
                if (res.code === 0) {
                    this.OrgsList = res.data
                }
            })
        },
    },
    created () {
        this.getOrgs()
    }
}
</script>

<style lang="less" scoped>
a {
    padding: 0;
    margin: 0;
    list-style: none;
    font-style: normal;
    text-decoration: none;
    border: none;
    font-family: Microsoft Yahei,sans-serif;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
}
.foundation {
    width: 1200px;
    margin: 0 auto;
    .entry {
        .item_entry {
            background-image: url(../../src/assets/public_log.png);
            background-repeat: no-repeat;
            background-size: cover;
            height: 120px;
            h3 {
                font-size: 19px;
                color: #fff;
                font-weight: 600;
                padding-top: 20px;
                line-height: 28px;
            }
            h4 {
                font-size: 15px;
                color: #fff;
                font-weight: 500;
                padding-top: 5px;
                line-height: 24px;
                i {
                    font-size: 17px;
                }
            }
            .apply_join {
                padding: 3px 10px;
                background-color: #fff;
                width: 87px;
                margin: 0 auto;
                border-radius: 20px;
                margin-top: 5px;
                color: #7e1505;
                font-size: 13px;
                line-height: 18px;
            }
        }
    }
    .item {
        display: inline-block;
        margin-top: 12px;
        width: 33.33%;
        .project_wrap {
            display: flex;
            margin: 5px;
            padding: 15px;
            background-color: #fff;
            border-radius: 4px;
            align-items: center;
            border: 1px solid #eee;
            box-shadow: 0 5px 20px hsla(0,0%,85%,.5);
            transition: all .3s linear;
            &:hover {
              box-shadow: 0 5px 20px rgba(0,0,0,.3);
            }
            .product_content{
                flex: 1;
                padding-right: 18px;
                text-align: left;
                width: 60%;
                .item_title {
                    margin: 0;
                    font-size: 16px;
                    color: #333;
                    font-weight: 600;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .item_intro {
                    height: 40px;
                    margin: 10px 0;
                    font-size: 14px;
                    color: #999;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    -webkit-box-orient: vertical;
                }
                .item_bottom {
                    display: flex;
                    justify-content: space-between;
                    .item_bottom_num {
                        font-size: 13px;
                        color: #999;
                        white-space: nowrap;
                        span {
                            color: #ed2424;
                        }
                    }
                }
            }
            .product_img {
                width: 70px;
                height: 70px;
                margin: 10px auto;
                img {
                    border-radius: 50%;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>
